<li
  class="cc-channel-item list-mode"
  draggable="true"
  [ngClass]="{ dragged: dragged }"
>
  <section>
    <icn-image [url]="channel.image" *ngIf="channel.image"></icn-image>
  </section>
  <footer>
    <span>{{ channel.name }}</span>
  </footer>
</li>
